import React from "react";
import { Pencil, Trash2, Building2, UserCog, Users } from "lucide-react";
import { companyShort } from "../../companies";

export const DepartmentCard = ({ d, onEdit, onDelete }) => (
  <div className="bg-white border border-gray-200 rounded-lg p-5">
    <div className="flex items-start justify-between">
      <span className="w-11 h-11 rounded-lg bg-[#16345c]/10 text-[#16345c] flex items-center justify-center mb-3"><Building2 size={22} /></span>
      <div className="flex gap-1">
        <button onClick={() => onEdit(d)} className="w-8 h-8 flex items-center justify-center rounded-sm text-[#16345c] hover:bg-[#16345c]/10 transition-colors"><Pencil size={15} /></button>
        <button onClick={() => onDelete(d)} className="w-8 h-8 flex items-center justify-center rounded-sm text-[#c00510] hover:bg-red-50 transition-colors"><Trash2 size={15} /></button>
      </div>
    </div>
    <div className="flex items-center gap-2 flex-wrap"><span className="text-[16px] font-bold text-[#16345c]">{d.name}</span><span className="text-[9px] font-bold uppercase px-1.5 py-0.5 rounded-full bg-slate-100 text-slate-600">{companyShort(d.company)}</span></div>
    <div className="text-[12.5px] text-gray-500 mb-3">{d.description || "—"}</div>
    <div className="flex items-center justify-between text-[12px] pt-3 border-t border-gray-100">
      <span className="flex items-center gap-1 text-gray-600"><UserCog size={13} /> {d.manager_name || "Nessun responsabile"}</span>
      <span className="flex items-center gap-1 text-gray-600"><Users size={13} /> {d.members_count}</span>
    </div>
  </div>
);
